import React from 'react'
import ReactDOM from 'react-dom/client'
import SheetPileApp from '../landing/SheetPileApp'
import '../styles/landing.css'

import type { User } from '@/types/user'

declare global {
  interface Window {
    railsData: {
      currentPath: string
      currentUser: User | null
      csrfToken: string
      controller: string
      action: string
      pageData: Record<string, unknown>
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const landingRoot = document.getElementById('landing-root')

  if (landingRoot && window.railsData) {
    const root = ReactDOM.createRoot(landingRoot)

    root.render(
      React.createElement(
        React.StrictMode,
        null,
        React.createElement(SheetPileApp, {
          ...window.railsData,
        }),
      ),
    )
  }
})
